import { getPlatform } from '@/lib/platform';

export const APP_VERSION_HEADER = 'X-App-Version';

let versionHeaders: Promise<Record<string, string>> | null = null;

/**
 * Native app: its store version, so the API can turn away a build older than
 * `MIN_NATIVE_APP_VERSION` (VOL-14); nothing on the website. Read once; a failed
 * read is retried on the next request, which meanwhile leaves without it.
 */
export function appVersionHeaders(): Promise<Record<string, string>> {
  versionHeaders ??= Promise.resolve()
    .then(() => getPlatform().app.info())
    .then((info): Record<string, string> => (info ? { [APP_VERSION_HEADER]: info.version } : {}))
    .catch((): Record<string, string> => {
      versionHeaders = null;
      return {};
    });
  return versionHeaders;
}

/** Tests only. */
export function __resetAppVersion(): void {
  versionHeaders = null;
}
